import { render } from "./DropdownWrapper.vue?vue&type=template&id=37d98c48&scoped=true"
import script from "./DropdownWrapper.vue?vue&type=script&lang=js"
export * from "./DropdownWrapper.vue?vue&type=script&lang=js"

import "./DropdownWrapper.vue?vue&type=style&index=0&id=37d98c48&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d98c48"]])

export default __exports__